import moment from 'moment';

import { AudienceProfileModal } from '@/components/Targeting/AudienceTargeting/AudienceProfile/components/AudienceProfileModal';
import { useTargetingContext } from '@/contexts/Targeting/TargetingContext';

type Props = {
  defaultSelectedItems: Record<string, boolean>;
  isModalOpened: boolean;
  onModalClose: () => void;
  onModalSave: (items: Record<string, any>[]) => void;
  theme?: 'light' | 'dark';
};

function PreviousCampaignModal({
  defaultSelectedItems,
  isModalOpened,
  onModalClose,
  onModalSave,
  theme = 'light'
}: Props) {
  const { user } = useTargetingContext();

  const parseData = (res: { items: Record<string, any>[] }) =>
    res?.items?.map((item: any) => {
      const bDate = moment(item.beginDate).format('DD/MM/YYYY');
      const eDate = moment(item.endDate).format('DD/MM/YYYY');
      return {
        ...item,
        id: item._id.toString(),
        name: `${item.name} - ${bDate} - ${eDate}`
      };
    }) || [];

  const formatRequestArgs = (page: number, size: number, filterText: string | null | undefined) => ({
    data: {
      filterCompleted: true,
      filterForecasting: true,
      filterString: filterText,
      limit: size,
      order: 'desc',
      page: page + 1,
      sortBy: 'modified'
    },
    method: 'POST'
  });

  return (
    <AudienceProfileModal
      defaultSelectedItems={defaultSelectedItems}
      formatRequestArgs={formatRequestArgs}
      isModalOpened={isModalOpened}
      onModalClose={onModalClose}
      onModalSave={onModalSave}
      parseData={parseData}
      tableConfig={{
        toolbar: { showSelectAll: false }
      }}
      tableProps={{
        hideSelectAllCheckbox: true,
        hideShowSelectedFilter: false
      }}
      theme={theme}
      url={`${taptap.config.sonataBackendUrl}campaigns/${user._id}/audienceBuilder`}
    />
  );
}

export default PreviousCampaignModal;
